export default __webpack_public_path__ + "static/Graphik-MediumItalic-Web-b266fc0de67985a1929bb272d98b11b2.woff";